<template>
    <div>
        <div class="header">
            {{ $vuetify.lang.t('$vuetify.billboardAndIndividual.messageManagement') }}
        </div>
        <nav-bar
            ref="navbar"
            @menu-change="menuChange"
            :menuItem="navbarList">
        </nav-bar>

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Billboard from '@/components/Message/Billboard.vue'
import Individual from '@/components/Message/Individual.vue'
// import permissionConstant from '@/constants/permissions.js'

export default {
    name: 'Message',

    components: {
        NavBar,
        Billboard,
        Individual
    },
    computed: {
        menuItem () {
            return [
                {
                    title: this.$vuetify.lang.t('$vuetify.billboard.billboard'),
                    path: 'Billboard',
                    pathName: 'billboard',
                    permission: [
                        // permissionConstant.billboard.view
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.individual.individual'),
                    path: 'Individual',
                    pathName: 'individual',
                    permission: [
                        // permissionConstant.individual.view
                    ]
                }
            ]
        },
        navbarList () {
            const navbar = []
            for (let i = 0; i < this.menuItem.length; i++) {
                // const show = this.menuItem[i].permission.some(p => this.userPermissions.includes(p))
                // if (show) {
                navbar.push(this.menuItem[i])
                // }
            }
            return navbar
        }
    },
    data () {
        return {
            component: 'Billboard',
            userPermissions: []
        }
    },

    methods: {
        menuChange (payload) {
            this.component = payload.path

            const path = `/message/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        navbarPermission () {
            this.component = this.navbarList[0].path
        },

        setActive (path) {
            let index = 0
            if (path === 'Message') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            const directPath = `/message/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.userPermissions = this.$store.state.permissions
        this.navbarPermission()
        this.setActive(this.$router.currentRoute.name)
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
}
</style>
